import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import useDorisMarketShareHooks from 'src/serverProxy/useDorisMarketShareHooks';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import {
  useBusinessUnitEntity,
  useCategoryEntity,
  useSegmentEntity,
  useSubcategoryEntity
} from 'src/utils/Hooks/reduxSelectors';

const AtlasSales1PTotalSalesSplineChart = () => {
  const { requestBuilder: defaultMarketShareNumeratorRequestBuilder } = useDorisMarketShareHooks();
  const { isSegmentEntity } = useSegmentEntity();
  const { isBusinessUnitEntity } = useBusinessUnitEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();

  return (
    <AtlasV2DorisSplineChart
      queryKey="RetailSales1PTotalSalesSplineChart"
      title="1P Retail Sales as % of Total"
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType="firstPartySales"
      showMarketShare={true}
      marketShareNumeratorRequestBuilder={(params) => {
        const returnParams = { ...defaultMarketShareNumeratorRequestBuilder(params) };
        if (isSegmentEntity || isBusinessUnitEntity || isCategoryEntity || isSubcategoryEntity) {
          returnParams.brandIds = [];
        }
        return returnParams;
      }}
      marketShareRequestBuilder={(params) => {
        return {
          ...params,
          metricType: 'retailSales'
        };
      }}
    />
  );
};

export default AtlasSales1PTotalSalesSplineChart;
